import { BirthdayAlumni } from './BirthdayService';

interface Props {
    alumni: BirthdayAlumni;
}

function initials(firstName: string, lastName: string): string {
    const a = (firstName || '').trim().charAt(0).toUpperCase();
    const b = (lastName || '').trim().charAt(0).toUpperCase();
    return `${a}${b}` || '?';
}

function roleLine(alumni: BirthdayAlumni): string | null {
    const role = alumni.currentRole?.trim() || '';
    const company = alumni.currentCompany?.trim() || '';
    if (role && company) return `${role} @ ${company}`;
    if (company) return company;
    if (role) return role;
    return null;
}

function batchLine(alumni: BirthdayAlumni): string {
    const program = alumni.programName?.trim() || '';
    if (program) return `Batch ${alumni.passOutYear} · ${program}`;
    return `Batch ${alumni.passOutYear}`;
}

const BirthdayAlumniCard = ({ alumni }: Props) => {
    const href = `/alumni/${alumni.studentUuid}/profile`;
    const role = roleLine(alumni);
    const city = alumni.city?.trim() || null;

    return (
        <div className="col">
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="bd-card text-decoration-none text-reset d-flex align-items-start">
                <div className="bd-card-photo">
                    {alumni.profilePictureUrl ? (
                        <img src={alumni.profilePictureUrl} alt={`${alumni.firstName} ${alumni.lastName}`} />
                    ) : (
                        <span className="bd-card-photo-initials">{initials(alumni.firstName, alumni.lastName)}</span>
                    )}
                </div>
                <div className="bd-card-body flex-1">
                    <div className="bd-card-name">
                        {alumni.firstName} {alumni.lastName}
                    </div>
                    {role && <div className="bd-card-role">{role}</div>}
                    <div className="bd-card-batch">{batchLine(alumni)}</div>
                    {city && <div className="bd-card-city">{city}</div>}
                </div>
            </a>
        </div>
    );
};

export default BirthdayAlumniCard;
